// Filename - App.js
 
import React from "react";
import { BrowserRouter as Router, Routes, Route, } from "react-router-dom";
import "./styles/App.css";
import Home from "./pages";
import About from "./pages/about";
import Blog from "./pages/blog";
import Photography from "./pages/photography";
import Contact from "./pages/contact";
 
function App() {
    return (
        <Router className="App">
             <Routes>
                <Route exact path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/photography" element={<Photography />} />
                <Route path="/contact" element={<Contact />} />
            </Routes>
        </Router>
    );
}
 
export default App;